"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var react_router_dom_1 = require("react-router-dom");
var InitiateSidebar_1 = __importDefault(require("./InitiateSidebar"));
function WrappedInitiateSidebar() {
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(InitiateSidebar_1.default, null)));
}
document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('initiate-vertical-sidebar');
    if (container) {
        var root = (0, client_1.createRoot)(container);
        root.render(react_1.default.createElement(WrappedInitiateSidebar, null));
    }
});
